import React, { Component } from 'react';
//import Filter from './FilterService'
// Material components
import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment'
import 'moment/locale/es'
import styles from './styles';
import {especial} from '../../../common/constants'
import {ObjectiveConfig} from '../../../services/ObjectiveConfig'
moment.locale('es')

class Header extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,
            image:null,
            tittle:null,
        }
    }

    

    componentDidMount() {
        this.processData();
    }

    processData(){
        ObjectiveConfig(especial).then( data => {
            this.props.callbackFromParent(data);
            this.setState({
                tittle:data.titulo,
                image:data.imagen,
                isLoading:false
            }); 
        })
    }

    render() {
        const {isLoading, tittle, image}=this.state
        const {classes}=this.props
        if(isLoading===true){
            return(
                <Grid container
                direction="row"
                justify="center"
                alignItems="center">
                    <Grid item lg={12} xl={12}>
                        <Typography
                            variant="h2"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={80}
                            thickness={3}
                            
                            />
                            Cargando Grupos...
                        </Typography>
                    </Grid>
                </Grid>
            )
        }else{
            return(
                <Grid container
                direction="row"
                justify="space-between"
                alignItems="center"
                >
                    <Grid item lg={4} xl={4}>
                        <img style={{height:"87px"}} src={`data:image/jpg;base64,${image}`}></img>
                    </Grid>
                    <Grid item lg={4} xl={4}>
                        <Typography variant="h4" className={classes.textTittle}>{tittle}</Typography>
                    </Grid>
                    <Grid item lg={4} xl={4} style={{textAlign:"right"}}>
                        <img alt="www.atentus.com" style={{height:"29px"}} src="atentus.png"></img>
                    </Grid>
                </Grid>
            )
        }
        
    }
}
export default
    compose(withStyles(styles))(Header);